(() => {
  'use strict';
  const configNode = document.getElementById('KdkNativeConfig');
  if (!configNode || window.KdkNative) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  document.documentElement.classList.add('kdk-native-enabled');
  const t = (key, vars = {}) => Object.entries(vars).reduce((s, [k, v]) => s.replaceAll(`:${k}:`, String(v)), config.strings[key] || key);
  const mobile = matchMedia('(max-width:1006px)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const colors = ['#ffffff','#f2f2f2','#d2d2d2','#fdf6ee','#c5c1b6','#e3d1c5','#b0af90'];
  const context = [config.theme, config.locale, config.country, config.currency].join(':');
  const storagePrefix = `kdk:native:v2:${context}:`;
  const snapshotVersion = config.version;
  const read = key => { try { return JSON.parse(sessionStorage.getItem(storagePrefix + key)); } catch (_) { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(storagePrefix + key, JSON.stringify(value)); return true; } catch (_) { return false; } };
  const remove = key => { try { sessionStorage.removeItem(storagePrefix + key); } catch (_) {} };
  const previewKeys = ['preview_theme_id','preview_key','pb','_fd','_ab','preview_script_id','theme_editor_session_id'];
  function localURL(raw) {
    const url = new URL(raw, location.origin);
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) throw Error('Cross-origin URL');
    const current = new URL(location.href);
    for (const key of previewKeys) if (current.searchParams.has(key) && !url.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    if (current.searchParams.get('view')==='kdk-native' && url.pathname===current.pathname && !url.searchParams.has('view')) url.searchParams.set('view','kdk-native');
    return url;
  }
  function request(raw, signal) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort('timeout'), 15000);
    const abort = () => controller.abort();
    if (signal?.aborted) controller.abort(); else signal?.addEventListener('abort', abort, {once:true});
    return fetch(localURL(raw), {credentials:'same-origin', signal:controller.signal, headers:{Accept:'text/html'}})
      .then(response => { if (!response.ok) throw Error(`HTTP ${response.status}`); return response.text(); })
      .finally(() => { clearTimeout(timer); signal?.removeEventListener('abort', abort); });
  }
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  function cleanFragment(node) {
    node.querySelectorAll('script,iframe,object,embed').forEach(x => x.remove());
    node.querySelectorAll('*').forEach(x => [...x.attributes].forEach(a => {
      if (/^on/i.test(a.name) || (/^(href|src)$/i.test(a.name) && /^\s*javascript:/i.test(a.value))) x.removeAttribute(a.name);
    }));
    return node;
  }
  const emit = (name, detail) => document.dispatchEvent(new CustomEvent(`kdk:native:${name}`, {detail}));
  const eligibleClick = e => e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
  const state = {view:read('preferences')?.view === 'inspo' ? 'inspo' : 'grid', wall:read('preferences')?.wall || '#f2f2f2'};
  if (!colors.includes(state.wall)) state.wall = '#f2f2f2';
  document.documentElement.dataset.kdkNativeView = state.view;
  let catalog = null;
  let filterReturnFocus = null;
  let suppressHeaderFocusUntil = 0;
  const dialogSet = new Set();
  function overlayState() {
    document.documentElement.classList.toggle('kdk-native-overlay-open', [...dialogSet].some(d => d.open) || (mobile.matches && !!catalog?.root.querySelector('[data-native-filter-shell][open]')));
    document.dispatchEvent(new CustomEvent('kdk:native:overlay'));
    videoSet.forEach(updateVideo);
  }
  function dialog(title, kind = '') {
    const opener = document.activeElement;
    const element = document.createElement('dialog');
    element.className = `kdk-native-dialog ${kind}`;
    const panel = document.createElement('div'); panel.className = 'kdk-native-dialog-panel';
    const head = document.createElement('header');
    const heading = document.createElement('h2'); heading.id = `kdk-dialog-title-${++dialog.counter}`; heading.textContent = title;
    element.setAttribute('aria-labelledby', heading.id);
    const closeDialog = () => { suppressHeaderFocusUntil = Date.now()+500; element.close(); };
    element.addEventListener('keydown', e => {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeDialog(); }
    });
    const close = document.createElement('button'); close.type = 'button'; close.textContent = `${t('close')} ×`; close.addEventListener('click', closeDialog);
    head.append(heading, close);
    const body = document.createElement('div'); body.className = 'kdk-native-dialog-body';
    panel.append(head, body); element.append(panel); document.body.append(element); dialogSet.add(element);
    const controller = new AbortController();
    element.addEventListener('click', e => { if (e.target === element) closeDialog(); });
    element.addEventListener('cancel', () => { suppressHeaderFocusUntil = Date.now()+500; });
    element.addEventListener('close', () => {
      controller.abort(); element.querySelectorAll('video').forEach(v => v.pause());
      dialogSet.delete(element); element.remove(); overlayState();
      if (opener?.isConnected && ![...dialogSet].some(d => d.open)) { suppressHeaderFocusUntil = Date.now()+500; opener.focus({preventScroll:true}); }
    }, {once:true});
    element.showModal(); overlayState();
    return {element, body, controller, heading};
  }
  dialog.counter = 0;
  const mediaCards = new Set();
  const mediaBound = new WeakSet();
  function wantsScene(card) {
    return card?.dataset.nativeHasScene !== 'false' && (state.view === 'inspo' || card?.classList.contains('kdk-native-editorial'));
  }
  function mediaSource(image) {
    if (!image) return;
    if (!mediaBound.has(image)) {
      mediaBound.add(image);
      image.addEventListener('load', () => {
        const card = image.closest('.kdk-native-card');
        card?.classList.add('kdk-native-scene-ready'); card?.classList.remove('kdk-native-scene-failed');
      });
      image.addEventListener('error', () => image.closest('.kdk-native-card')?.classList.add('kdk-native-scene-failed'));
    }
    image.loading = 'eager';
    const width=image.closest('.kdk-native-card')?.clientWidth; if(width)image.sizes=Math.ceil(width)+'px';
    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    if (image.dataset.src) image.src = image.dataset.src;
    if (image.complete && image.naturalWidth) image.closest('.kdk-native-card')?.classList.add('kdk-native-scene-ready');
  }
  function prepareCard(card) {
    const rect = card.getBoundingClientRect();
    if (rect.bottom < -700 || rect.top > innerHeight + 900) return;
    if (wantsScene(card)) mediaSource(card.querySelector('[data-native-scene]'));
    else {
      const image = card.querySelector('.kdk-native-art');
      if (image) image.loading = 'eager';
    }
  }
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) prepareCard(entry.target);
  }), {rootMargin:'900px 0px', threshold:0});
  const videoSet = new Set();
  const playingVideos = new WeakSet();
  let scrollDirection = 0, lastScroll = scrollY;
  function prepareVideo(video, play = false) {
    video.muted = true; video.playsInline = true; video.loop = true; video.controls = false;
    if (!video.getAttribute('src') && video.dataset.src) {
      video.preload = 'auto'; video.src = video.dataset.src; video.load();
    }
    if (play && video.paused && !playingVideos.has(video)) {
      playingVideos.add(video);
      Promise.resolve(video.play()).catch(() => {}).finally(() => playingVideos.delete(video));
    }
  }
  function updateVideo(video) {
    if (state.view === 'inspo' || !video.isConnected || document.hidden || reduced.matches || document.documentElement.classList.contains('kdk-native-overlay-open')) { video.pause(); return; }
    const r = video.getBoundingClientRect();
    if (!r.width || !r.height) { video.pause(); return; }
    const visible = r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth;
    const approaching = (scrollDirection >= 0 && r.top >= innerHeight && r.top < innerHeight + 220) || (scrollDirection < 0 && r.bottom <= 0 && r.bottom > -220);
    if (r.top < innerHeight + 650 && r.bottom > -650) prepareVideo(video);
    if (visible || approaching) prepareVideo(video, true); else video.pause();
  }
  const videoObserver = new IntersectionObserver(entries => entries.forEach(entry => updateVideo(entry.target)), {rootMargin:'650px 0px', threshold:[0,0.01,1]});
  let wishlistItems = null, wishlistRead = null, wishlistTimer = null;
  const wishlistPending = new Set();
  const wishlistBound = new WeakSet();
  const wishlistVariant = el => String(el.getAttribute('data-wlh-variantid'));
  const wishlistContains = id => wishlistItems?.some(item => String(item.ProductVariantId ?? item.productVariantId) === id);
  const wishlistIcons = {"far": "<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"far\" data-icon=\"heart\" class=\"svg-inline--fa fa-heart fa-w-16 fa-1x \" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" color=\"rgba(0, 0, 0, 0.6880596787182253)\"><path fill=\"currentColor\" d=\"M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z\"></path></svg>", "fas": "<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"heart\" class=\"svg-inline--fa fa-heart fa-w-16 fa-1x \" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" color=\"rgba(255, 0, 0, 1)\"><path fill=\"currentColor\" d=\"M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z\"></path></svg>"};
  function paintWishlist() {
    document.querySelectorAll('.kdk-native-wishlist').forEach(el => {
      const button = el.querySelector('[data-native-wishlist-button]'); if (!button) return;
      const id = wishlistVariant(el), saved = !!wishlistContains(id), busy = wishlistPending.has(id);
      button.disabled = !window.WishListHero_SDK || busy;
      button.setAttribute('aria-busy', String(busy));
      if (wishlistItems === null) return;
      const label = t(saved ? 'wishlist_remove' : 'wishlist_add');
      button.setAttribute('aria-pressed', String(saved)); button.setAttribute('aria-label', label);
      button.title = el.querySelector('[data-native-wishlist-status]')?.textContent || label;
      const prefix = saved ? 'fas' : 'far';
      if (button.querySelector('svg')?.dataset.prefix !== prefix) button.innerHTML = wishlistIcons[prefix];
    });
    if (wishlistItems !== null) document.querySelectorAll('.wishlist-hero-items-count').forEach(el => {
      el.textContent = String(wishlistItems.length);
      el.style.display = wishlistItems.length ? 'flex' : 'none';
      el.classList.toggle('wishlist-hero-items-count-exists', wishlistItems.length > 0);
    });
  }
  async function refreshWishlist() {
    const sdk = window.WishListHero_SDK;
    if (!sdk) return;
    if (wishlistRead) return wishlistRead;
    wishlistRead = (async () => {
      const hash = sdk.GetWishListHash(false);
      if (hash && typeof hash !== 'string') throw Error('Wishlist unavailable');
      const items = hash ? await sdk.GetWishListItemsFromServer() : [];
      if (!Array.isArray(items)) throw Error('Wishlist read failed');
      wishlistItems = items; paintWishlist(); return items;
    })();
    try { return await wishlistRead; } finally { wishlistRead = null; }
  }
  function queueWishlistRefresh() {
    if (wishlistTimer !== null) return;
    wishlistTimer = setTimeout(() => {
      wishlistTimer = null;
      if (wishlistPending.size) return;
      refreshWishlist().catch(() => {});
    }, 0);
  }
  async function changeWishlist(el) {
    const id = wishlistVariant(el), sdk = window.WishListHero_SDK;
    if (!sdk || wishlistPending.has(id)) return;
    if (window.WishListHero_setting?.DisableGuestCustomer && !sdk.GetCustomerId()) {
      document.dispatchEvent(new Event('wishlist-hero-open-login-popup')); return;
    }
    wishlistPending.add(id); paintWishlist();
    let status = el.querySelector('[data-native-wishlist-status]');
    if (!status) { status = document.createElement('span'); status.className = 'u-visually-hidden'; status.dataset.nativeWishlistStatus = ''; status.setAttribute('role','status'); el.append(status); }
    status.textContent = '';
    try {
      await refreshWishlist();
      const saved = !!wishlistContains(id);
      let hash = sdk.GetWishListHash(false), timer;
      if (!hash) {
        try { hash = await Promise.race([sdk.GetWishListHash(true), new Promise((_, reject) => { timer = setTimeout(() => reject(Error('Wishlist creation timeout')), 12000); })]); }
        finally { clearTimeout(timer); }
      }
      if (typeof hash !== 'string' || !hash) throw Error('Wishlist unavailable');
      const customerId = sdk.GetCustomerId();
      const result = saved ? await sdk.DeleteWishListItem({WishlistHash:hash, ProductVariantId:id}) : await sdk.AddWishListItem({
        WishlistHash:hash, ...(customerId ? {CustomerId:customerId} : {}), ProductId:el.dataset.wlhId, ProductVariantId:id,
        ProductTitle:el.dataset.wlhName, ProductPrice:Number(el.dataset.wlhPrice), ProductLink:el.dataset.wlhLink, ProductImage:el.dataset.wlhImage || ''
      });
      if (!result?.ok) throw Error('Wishlist write failed');
      await refreshWishlist();
      if (!!wishlistContains(id) === saved) throw Error('Wishlist confirmation failed');
    } catch (_) {
      status.textContent = t('wishlist_error');
      el.querySelector('button').title = t('wishlist_error');
    } finally { wishlistPending.delete(id); paintWishlist(); }
  }
  function wishlist(root = document) {
    root.querySelectorAll('.kdk-native-wishlist').forEach(el => {
      el.classList.remove('wishlist-hero-custom-button');
      if (wishlistBound.has(el)) return;
      wishlistBound.add(el);
      const button = document.createElement('button'); button.type = 'button'; button.dataset.nativeWishlistButton = '';
      button.disabled = true; button.setAttribute('aria-label', t('wishlist')); button.innerHTML = wishlistIcons.far;
      button.addEventListener('click', () => changeWishlist(el)); el.replaceChildren(button);
    });
    paintWishlist();
  }
  document.addEventListener('wishlist-hero-wishlist-updated', queueWishlistRefresh);
  document.addEventListener('wishlist-hero-wishlist-hash-generated', queueWishlistRefresh);
  document.addEventListener('wishlist-hero-links-binded', paintWishlist);
  let openSort = null;
  let sortCounter = 0;
  const sortWidgets = new WeakMap();
  function closeSort(restoreFocus = false) {
    if (!openSort) return;
    const widget = openSort; openSort = null;
    widget.menu.hidden = true; widget.trigger.setAttribute('aria-expanded','false');
    if (restoreFocus && widget.trigger.isConnected) widget.trigger.focus({preventScroll:true});
  }
  function syncSortForms(root = document) {
    const forms = [...(root.matches?.('[data-native-sort-form]') ? [root] : []), ...root.querySelectorAll('[data-native-sort-form]')];
    forms.forEach(form => {
      const select = form.querySelector('[data-native-sort]'); if (!select) return;
      let widget = sortWidgets.get(form);
      if (!widget) {
        form.querySelectorAll('[data-native-sort-ui]').forEach(el => el.remove());
        const label = form.querySelector('label')?.textContent.trim() || t('sort');
        const trigger = document.createElement('button'); trigger.type='button'; trigger.className='kdk-native-sort-trigger'; trigger.dataset.nativeSortUi='';
        const value = document.createElement('span'); value.className='kdk-native-sort-value'; value.setAttribute('aria-hidden','true');
        const mobileLabel = document.createElement('span'); mobileLabel.className='kdk-native-sort-mobile'; mobileLabel.textContent=label; mobileLabel.setAttribute('aria-hidden','true');
        trigger.append(value,mobileLabel);
        const menu = document.createElement('div'); menu.className='kdk-native-sort-menu'; menu.id=`KdkSortMenu-${++sortCounter}`; menu.dataset.nativeSortUi=''; menu.role='listbox'; menu.setAttribute('aria-label',label); menu.hidden=true;
        trigger.setAttribute('aria-haspopup','listbox'); trigger.setAttribute('aria-controls',menu.id); trigger.setAttribute('aria-expanded','false');
        widget={form,select,trigger,menu,value,label}; sortWidgets.set(form,widget);
        const options = [...select.options];
        options.forEach(option => {
          const button=document.createElement('button'); button.type='button'; button.className='kdk-native-sort-option'; button.role='option'; button.tabIndex=-1; button.dataset.value=option.value; button.textContent=option.textContent.trim(); button.disabled=option.disabled;
          button.addEventListener('click',()=>{
            if (button.disabled) return;
            const changed=select.value!==button.dataset.value;
            select.value=button.dataset.value; syncSortForms(form); closeSort(true);
            if (changed) select.dispatchEvent(new Event('change',{bubbles:true}));
          });
          menu.append(button);
        });
        const show = (index = select.selectedIndex) => {
          closeSort(); openSort=widget; menu.hidden=false; trigger.setAttribute('aria-expanded','true');
          const buttons=[...menu.querySelectorAll('button:not(:disabled)')];
          (buttons.find(b=>b.dataset.value===options[index]?.value)||buttons[0])?.focus({preventScroll:true});
        };
        trigger.addEventListener('click',()=>openSort===widget ? closeSort(true) : show());
        form.addEventListener('keydown',event=>{
          const keys=['ArrowDown','ArrowUp','Home','End'];
          if (keys.includes(event.key) && (event.target===trigger || menu.contains(event.target))) {
            event.preventDefault();
            if (openSort!==widget) { show(event.key==='Home'?0:event.key==='End'?options.length-1:select.selectedIndex); return; }
            const buttons=[...menu.querySelectorAll('button:not(:disabled)')]; const current=buttons.indexOf(document.activeElement);
            const index=event.key==='Home'?0:event.key==='End'?buttons.length-1:Math.max(0,Math.min(buttons.length-1,current+(event.key==='ArrowDown'?1:-1)));
            buttons[index]?.focus({preventScroll:true});
          } else if(event.key==='Escape' && openSort===widget) { event.preventDefault(); event.stopPropagation(); closeSort(true); }
          else if(event.key==='Tab' && openSort===widget) closeSort();
        });
        form.append(trigger,menu); select.hidden=true; form.classList.add('kdk-native-sort-enhanced');
      }
      const selected=select.selectedOptions[0]; widget.value.textContent=selected?.textContent.trim() || '';
      widget.trigger.setAttribute('aria-label',`${widget.label}: ${widget.value.textContent}`);
      widget.menu.querySelectorAll('[role=option]').forEach(button=>button.setAttribute('aria-selected',String(button.dataset.value===select.value)));
    });
  }
  function scrollQuickImage(image) {
    const gallery=image.closest('[data-native-quick-gallery]'); if(!gallery)return;
    const left=gallery.scrollLeft+image.getBoundingClientRect().left-gallery.getBoundingClientRect().left;
    gallery.scrollTo({left:Math.max(0,Math.min(left,gallery.scrollWidth-gallery.clientWidth)),behavior:reduced.matches?'instant':'smooth'});
  }

  function mount(root) {
    syncSortForms(root);
    root.querySelectorAll('.kdk-native-card').forEach(card => { mediaCards.add(card); observer.observe(card); prepareCard(card); });
    root.querySelectorAll('[data-native-video]').forEach(video => { videoSet.add(video); videoObserver.observe(video); updateVideo(video); });
    root.querySelectorAll('a[href]').forEach(link => {
      try { const url = new URL(link.href); if (url.origin === location.origin) link.href = localURL(link.href).href; } catch (_) {}
    });
    wishlist(root);
  }
  function unmount(root) {
    if (openSort && root.contains(openSort.form)) closeSort();
    root.querySelectorAll('.kdk-native-card').forEach(card => { observer.unobserve(card); mediaCards.delete(card); });
    root.querySelectorAll('[data-native-video]').forEach(video => { video.pause(); videoObserver.unobserve(video); videoSet.delete(video); });
  }
  const nextFrame = () => new Promise(resolve => requestAnimationFrame(resolve));
  async function scrollProducts(root, target, waitForLayout = true) {
    if (!root?.isConnected || !target?.isConnected) return;
    const toolbar = root.querySelector('[data-native-toolbar]');
    if (mobile.matches) toolbar?.classList.add('is-condensed');
    if (waitForLayout) { await nextFrame(); await nextFrame(); }
    if(!root.isConnected || !target.isConnected)return;
    const top = toolbar ? (parseFloat(getComputedStyle(toolbar).top) || 0) : 0;
    const offset = Math.max(0, top) + (toolbar?.getBoundingClientRect().height || 0) + 14;
    scrollTo({top:Math.max(0, target.getBoundingClientRect().top + scrollY - offset), behavior:'instant'});
    catalog?.compact();
  }
  class Catalog {
    constructor(root) {
      this.root = root; this.currentURL = location.href; this.sequence = 0; this.pending = null; this.abort = null; this.prefetched = null; this.moreObserver = null;
      const returning = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
      if (!returning || !this.restore()) {
        this.hydrate();
        if (returning) window.KdkNativeHistory?.restore();
      }
      document.getElementById('KdkNativeRestoreSpace')?.remove();
    }
    hydrate() {
      this.root.classList.add('is-ready');
      document.documentElement.dataset.kdkNativeView = state.view;
      this.root.classList.toggle('is-inspo', state.view === 'inspo');
      this.root.style.setProperty('--kdk-wall', state.wall);
      this.root.querySelectorAll('[data-native-view]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.nativeView === state.view)));
      this.root.querySelectorAll('[data-native-wall]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.nativeWall.toLowerCase() === state.wall)));
      const shell = this.root.querySelector('[data-native-filter-shell]'); if (shell) shell.open = !mobile.matches;
      this.root.querySelectorAll('img.kdk-native-art').forEach((img, index) => {
        if (index < 2 && img.getBoundingClientRect().top < innerHeight) { img.loading = 'eager'; img.fetchPriority = 'high'; }
      });
      mount(this.root); this.compact(); overlayState(); this.watchMore();
    }
    compact() {
      const toolbar = this.root.querySelector('[data-native-toolbar]');
      if (toolbar) toolbar.classList.toggle('is-condensed', mobile.matches && scrollY > 1 && toolbar.getBoundingClientRect().top <= (parseFloat(getComputedStyle(toolbar).top) || 0) + 2);
    }
    snapshot() {
      window.KdkNativeHistory?.capture();
      if (!this.root.isConnected || this.root.getAttribute('aria-busy') === 'true') return;
      const copy = this.root.cloneNode(true);
      copy.querySelectorAll('[data-native-sort-ui]').forEach(el=>el.remove());
      copy.querySelectorAll('[data-native-sort-form]').forEach(form=>{
        form.classList.remove('kdk-native-sort-enhanced');
        const select=form.querySelector('[data-native-sort]'); if(select){select.hidden=false; [...select.options].forEach(option=>option.selected=option.defaultSelected);}
      });
      copy.querySelectorAll('.kdk-native-wishlist').forEach(el => el.replaceChildren());
      copy.querySelectorAll('[data-native-scene]').forEach(el=>el.removeAttribute('data-started'));
      copy.querySelectorAll('[data-native-error]').forEach(el=>el.hidden=true);
      const current=new URL(this.currentURL);
      const key = `snapshot:${current.pathname}${current.search}`;
      const html = copy.outerHTML;
      if (html.length > 900000) return;
      let order = read('snapshot_order') || [];
      order = order.filter(k => k !== key);
      while (order.length >= 3) remove(order.shift());
      if (write(key, {at:Date.now(),version:snapshotVersion,html,y:scrollY,height:this.root.getBoundingClientRect().height,width:innerWidth,view:state.view,wall:state.wall})) { order.push(key); write('snapshot_order',order); }
    }
    restore() {
      const saved = read(`snapshot:${location.pathname}${location.search}`);
      if (!saved || saved.version !== snapshotVersion || Date.now()-saved.at > 1800000 || typeof saved.html !== 'string') return false;
      const fresh = parse(saved.html).querySelector('[data-native-listing]');
      if (!this.valid(fresh)) return false;
      this.abort?.abort(); this.sequence++; this.pending=null;
      if (['grid','inspo'].includes(saved.view)) state.view = saved.view;
      if (colors.includes(saved.wall)) state.wall = saved.wall;
      unmount(this.root); this.root.replaceWith(fresh); this.root = fresh; this.currentURL=location.href; this.hydrate();
      if (!window.KdkNativeHistory?.restore()) scrollTo({top:Number(saved.y)||0,behavior:'instant'});
      return true;
    }
    valid(root) {
      return root && root.querySelector('[data-native-grid]') && root.querySelector('[data-native-pager]') && root.querySelector('[data-native-count]') && Number.isInteger(Number(root.dataset.page)) && Number(root.dataset.page)>0 && Number.isInteger(Number(root.dataset.total)) && Number(root.dataset.total)>=0 && root.dataset.section===this.root.dataset.section && root.dataset.mode===this.root.dataset.mode && root.dataset.locale === config.locale && root.dataset.country === config.country && root.dataset.currency === config.currency && String(root.dataset.theme) === String(config.theme);
    }
    sectionURL(raw) {
      const url = localURL(raw); url.searchParams.set('section_id', this.root.dataset.section); return url;
    }
    watchMore() {
      this.moreObserver?.disconnect();
      const more = this.root.querySelector('[data-native-more]');
      if (!more || navigator.connection?.saveData || ['slow-2g','2g'].includes(navigator.connection?.effectiveType)) return;
      this.moreObserver = new IntersectionObserver(entries => {
        if (!entries.some(e => e.isIntersecting) || document.hidden || this.pending) return;
        this.moreObserver.disconnect();
        const url = this.sectionURL(more.href);
        const entry = {url:url.href, at:Date.now(), promise:null, controller:new AbortController()};
        entry.promise = request(url, entry.controller.signal).then(html => html.length <= 2500000 ? html : null).catch(() => null);
        this.prefetched = entry;
      }, {rootMargin:'650px 0px'});
      this.moreObserver.observe(more);
    }
    async pageHTML(url, signal) {
      const entry = this.prefetched; this.prefetched = null;
      if (entry && entry.url === url.href && Date.now() - entry.at < 45000) {
        const abort = () => entry.controller.abort();
        if (signal?.aborted) abort(); else signal?.addEventListener('abort', abort, {once:true});
        let html;
        try { html = await entry.promise; }
        finally { signal?.removeEventListener('abort', abort); }
        if (signal?.aborted) throw new DOMException('Aborted','AbortError');
        if (html) return html;
      } else entry?.controller.abort();
      return request(url, signal);
    }
    formURL(form) {
      const url = localURL(form.action);
      url.searchParams.delete('page');
      for (const [key,value] of new FormData(form)) if (String(value).length) url.searchParams.append(key,String(value));
      return url;
    }
    async navigate(raw, append = false, historyMode = 'push') {
      if (append && this.root.getAttribute('aria-busy') === 'true') return;
      const restoreSortFocus = !!this.root.querySelector('[data-native-sort-form]')?.contains(document.activeElement);
      this.snapshot(); this.abort?.abort(); this.abort = new AbortController();
      this.moreObserver?.disconnect();
      if (!append) { this.prefetched?.controller.abort(); this.prefetched = null; }
      const sequence = ++this.sequence;
      const url = localURL(raw); url.searchParams.delete('section_id');
      const requestURL = new URL(url); requestURL.searchParams.set('section_id',this.root.dataset.section);
      const expanded=new Map([...this.root.querySelectorAll('[data-native-facet]')].map(el=>[el.dataset.nativeFacet,el.open]));
      this.pending = {raw:url.href, append, historyMode};
      this.root.setAttribute('aria-busy','true');
      this.root.dataset.loadingMode = append ? 'append' : 'replace';
      const moreButton = this.root.querySelector('[data-native-more]');
      if (append && moreButton) { moreButton.setAttribute('aria-disabled','true'); moreButton.setAttribute('aria-busy','true'); const label=moreButton.querySelector('[data-native-more-label]'); if(label) label.textContent=t('loading'); }
      let reservedSpace = null;
      if (append) {
        const grid = this.root.querySelector('[data-native-grid]');
        const count = grid.querySelectorAll('[data-native-product]').length;
        const remaining = Math.min(30, Number(this.root.dataset.total) - Number(this.root.dataset.offset) - count);
        if (count && remaining > 0) {
          // Reserve the next batch at the user's click, before waiting for the network.
          reservedSpace = document.createElement('div');
          reservedSpace.setAttribute('aria-hidden','true');
          reservedSpace.style.gridColumn = '1 / -1';
          reservedSpace.style.height = `${Math.ceil(grid.getBoundingClientRect().height * remaining / count)}px`;
          grid.append(reservedSpace);
        }
      }
      const error = this.root.querySelector('[data-native-error]'); if (error) error.hidden = true;
      try {
        const html = await this.pageHTML(requestURL, this.abort.signal);
        if (sequence !== this.sequence) return;
        const fresh = parse(html).querySelector('[data-native-listing]');
        if (!this.valid(fresh)) throw Error('Invalid section/context');
        const offset = Number(fresh.dataset.offset);
        const expectedCount = Math.min(30, Math.max(0, Number(fresh.dataset.total) - offset));
        if (!Number.isInteger(offset) || offset !== (Number(fresh.dataset.page) - 1) * 30) throw Error('Invalid page offset');
        if (fresh.dataset.blocked !== 'true' && fresh.querySelectorAll('[data-native-grid] [data-native-product]').length !== expectedCount) throw Error('Incomplete page');
        cleanFragment(fresh);
        if (append) {
          if (Number(fresh.dataset.page) !== Number(this.root.dataset.page)+1) throw Error('Unexpected page');
          const grid = this.root.querySelector('[data-native-grid]');
          const known = new Set([...grid.querySelectorAll('[data-native-product]')].map(x=>x.dataset.nativeProduct));
          if(!fresh.querySelector('[data-native-grid] [data-native-product]')) throw Error('Empty next page');
          for (const node of fresh.querySelector('[data-native-grid]').children) {
            if (node.dataset.nativeProduct) { if(known.has(node.dataset.nativeProduct)) throw Error('Duplicate product'); known.add(node.dataset.nativeProduct); }
          }
          const firstNew = fresh.querySelector('[data-native-grid] [data-native-product]');
          for (const node of [...fresh.querySelector('[data-native-grid]').children]) grid.insertBefore(node, reservedSpace);
          reservedSpace?.remove();
          this.root.querySelector('[data-native-pager]').replaceWith(fresh.querySelector('[data-native-pager]'));
          this.root.dataset.page = fresh.dataset.page; this.root.dataset.total=fresh.dataset.total;
          this.root.querySelector('[data-native-count]').replaceWith(fresh.querySelector('[data-native-count]'));
          const viewed = Math.min(Number(this.root.dataset.offset)+grid.querySelectorAll('[data-native-product]').length,Number(fresh.dataset.total));
          this.root.querySelector('[data-native-viewed]')?.replaceChildren(document.createTextNode(t('viewed',{n:viewed,total:fresh.dataset.total})));
          const progress = this.root.querySelector('[data-native-progress]'); if (progress) { progress.value=viewed; progress.setAttribute('aria-label',t('viewed',{n:viewed,total:fresh.dataset.total})); }
          this.root.classList.add('has-loaded-more'); mount(this.root);
          await scrollProducts(this.root, firstNew);
        } else {
          fresh.querySelectorAll('[data-native-facet]').forEach(el=>{if(expanded.has(el.dataset.nativeFacet))el.open=expanded.get(el.dataset.nativeFacet);});
          unmount(this.root); this.root.replaceWith(fresh); this.root=fresh; this.hydrate();
          if (restoreSortFocus) this.root.querySelector('.kdk-native-sort-trigger')?.focus({preventScroll:true});
          if (historyMode === 'push') history.pushState({...history.state,kdkNative:true},'',url.pathname+url.search);
          else if (historyMode === 'replace') history.replaceState({...history.state,kdkNative:true},'',url.pathname+url.search);
          this.currentURL=url.href;
          if (historyMode !== 'none') window.KdkNativeHistory?.changed();
          if (historyMode !== 'none' || !window.KdkNativeHistory?.restore()) await scrollProducts(this.root, this.root.querySelector('[data-native-grid]'), false);
        }
        if(sequence!==this.sequence)return;
        this.pending = null;
        emit(append?'load_more':'results',{mode:this.root.dataset.mode,page:Number(this.root.dataset.page),count:Number(this.root.dataset.total)});
      } catch (error) {
        if (sequence !== this.sequence) return;
        this.root.querySelector('[data-native-filter-form]')?.reset(); this.root.querySelector('[data-native-sort-form]')?.reset(); syncSortForms(this.root);
        const node=this.root.querySelector('[data-native-error]');
        if (node) { node.querySelector('span').textContent=t('load_error'); node.hidden=false; }
        emit('error',{component:'catalog',reason:error.name});
      } finally {
        reservedSpace?.remove();
        if (sequence===this.sequence) {
          this.root.removeAttribute('aria-busy'); delete this.root.dataset.loadingMode;
          const more=this.root.querySelector('[data-native-more]');
          if(more){more.removeAttribute('aria-disabled');more.removeAttribute('aria-busy');const label=more.querySelector('[data-native-more-label]');if(label)label.textContent=t('load_more');}
          overlayState(); this.watchMore();
        }
      }
    }
  }
  function filters(open, discard = false) {
    const shell=catalog?.root.querySelector('[data-native-filter-shell]'); if (!shell) return;
    if (open) filterReturnFocus=document.activeElement;
    if (discard) shell.querySelector('form')?.reset();
    shell.open=open||!mobile.matches;
    catalog.root.querySelector('[data-native-open-filters]')?.setAttribute('aria-expanded',String(open));
    const panel=shell.querySelector('[data-native-filter-panel]');
    if (mobile.matches && open) { panel.setAttribute('role','dialog'); panel.setAttribute('aria-modal','true'); panel.setAttribute('aria-label',t('filters')); panel.focus({preventScroll:true}); }
    else { panel.removeAttribute('role'); panel.removeAttribute('aria-modal'); if (filterReturnFocus?.isConnected) filterReturnFocus.focus({preventScroll:true}); }
    overlayState();
  }
  const scriptCache=new Map();
  function loadScript(src) {
    if (!src) return Promise.reject(Error('Missing preview asset'));
    if (scriptCache.has(src)) return scriptCache.get(src);
    const result=new Promise((resolve,reject) => {
      const script=document.createElement('script'); script.src=src; script.async=true;
      script.onload=resolve; script.onerror=()=>{scriptCache.delete(src);script.remove();reject(Error('Preview asset unavailable'));};
      document.head.append(script);
    });
    scriptCache.set(src,result); return result;
  }
  async function previewAssets() {
    if (window.KdkProductPreview?.init) return;
    await loadScript(window.KDK_PREVIEW_ASSETS?.sharedScene); await loadScript(window.KDK_PREVIEW_ASSETS?.modal);
    if (!window.KdkProductPreview?.init) throw Error('Preview API missing');
  }
  const previewRoots=new Map();
  async function visualize(button) {
    if (button.disabled) return;
    button.disabled=true; const initial=button.textContent; button.textContent=t('loading');
    try {
      const url=localURL(button.dataset.url); const variant=button.dataset.variant;
      const key=`${context}:${url.pathname}`;
      let root=previewRoots.get(key);
      if (!root?.isConnected) {
        url.searchParams.set('view','kdk-preview-embed');
        if (variant) url.searchParams.set('variant',variant);
        const [html]=await Promise.all([request(url),previewAssets()]);
        root=parse(html).querySelector('.kdk-pdp-preview'); if (!root) throw Error('Missing preview root');
        const uid=`native-${previewRoots.size+1}`;
        root.id=`kdk-product-preview-${uid}`; root.dataset.kdkPreviewInstance=uid; root.dataset.kdkMountToBody='true';
        const open=root.querySelector('[data-kdk-preview-open]'), modal=root.querySelector('[data-kdk-preview-modal]');
        if (open) { open.id=`kdk-product-preview-open-${uid}`; open.setAttribute('aria-controls',`kdk-product-preview-modal-${uid}`); }
        if (modal) modal.id=`kdk-product-preview-modal-${uid}`;
        if (variant) root.dataset.kdkInitialVariantId=variant;
        const host=document.createElement('div'); host.className='kdk-native-preview-host';host.append(root);document.body.append(host);
        window.KdkProductPreview.init(host);previewRoots.set(key,root);
      }
      if (variant) root.dataset.kdkInitialVariantId=variant;
      for (const d of dialogSet) d.close();
      overlayState();
      window.__kdkRefreshFloatingWidgets?.();
      const open=root.querySelector('[data-kdk-preview-open]');if (!open) throw Error('Missing preview launcher');open.click();
    } catch (error) {
      const d=dialog(t('visualize'));const p=document.createElement('p');p.textContent=t('load_error');
      const a=document.createElement('a');a.href=localURL(button.dataset.url);a.textContent=t('view_product');d.body.append(p,a);
      emit('error',{component:'visualizer',reason:error.name});
    } finally { if (button.isConnected) {button.disabled=false;button.textContent=initial;} }
  }
  const quickDescriptor = card => {
    const b = card.querySelector('[data-native-quick]');
    return b ? {id:card.dataset.nativeProduct, url:b.dataset.url, title:b.dataset.title || ''} : null;
  };
  async function prepareQuickGallery(content, signal) {
    await Promise.all([...content.querySelectorAll('[data-native-quick-gallery] > img')].map(async source => {
      const image = document.createElement('img');
      for (const attr of source.attributes) {
        if (!['src','srcset','sizes','loading'].includes(attr.name)) image.setAttribute(attr.name, attr.value);
      }
      image.loading = 'eager'; image.decoding = 'async';
      if (source.hasAttribute('sizes')) image.sizes=source.getAttribute('sizes');
      if (source.hasAttribute('srcset')) image.srcset=source.getAttribute('srcset');
      image.src=source.getAttribute('src');
      let timer, abort;
      const cancelled = new Promise((_, reject) => {
        abort = () => reject(new DOMException('Quick view closed', 'AbortError'));
        if (signal.aborted) abort(); else signal.addEventListener('abort', abort, {once:true});
        timer = setTimeout(() => reject(Error('Quick view image timeout')), 15000);
      });
      try {
        await Promise.race([image.decode(), cancelled]);
        if (signal.aborted || !image.naturalWidth) throw Error('Quick view image unavailable');
        source.replaceWith(image);
      } finally { clearTimeout(timer); signal.removeEventListener('abort', abort); }
    }));
  }
  async function quick(button) {
    const d = dialog(button.dataset.title || t('quick_view'), 'kdk-native-quick-dialog');
    d.heading.setAttribute('aria-live','polite');
    const source = catalog?.root;
    const listed = source && source.contains(button);
    const items = listed ? [...source.querySelectorAll('[data-native-grid] [data-native-product]')].map(quickDescriptor).filter(Boolean) : [{id:button.closest('[data-native-product]')?.dataset.nativeProduct || '',url:button.dataset.url,title:button.dataset.title||''}];
    const session = {items, index:Math.max(0,items.findIndex(item => localURL(item.url).pathname === localURL(button.dataset.url).pathname)),
      first:listed ? Math.floor(Number(source.dataset.offset)/30)+1 : 1, last:listed ? Number(source.dataset.page) : 1,
      pages:listed ? Math.ceil(Number(source.dataset.total)/30) : 1, base:listed ? catalog.currentURL : '',
      section:listed ? source.dataset.section : '', busy:false, cache:new Map(), contentMin:0};
    window.addEventListener('resize', () => {
      session.contentMin=0;
      d.body.querySelector('[data-native-quick-content]')?.style.removeProperty('--kdk-quick-content-min');
    }, {signal:d.controller.signal});
    const renderControls = content => {
      const nav = document.createElement('nav'); nav.className = 'kdk-native-product-controls'; nav.setAttribute('aria-label',t('products'));
      for (const direction of [-1,1]) {
        const b = document.createElement('button'); b.type='button'; b.dataset.nativeProductStep=String(direction);
        b.textContent = direction < 0 ? `← ${t('previous_product')}` : `${t('next_product')} →`;
        b.disabled = session.busy || (direction<0 ? session.index===0 && session.first===1 : session.index===session.items.length-1 && session.last>=session.pages);
        const adjacent = session.items[session.index+direction]; if(adjacent)b.setAttribute('aria-label',`${direction<0?t('previous_product'):t('next_product')} · ${adjacent.title}`);
        b.addEventListener('click',()=>move(direction)); nav.append(b);
      }
      content.querySelector('[data-native-quick-gallery]')?.after(nav);
    };
    const boundary = async direction => {
      const page = direction<0 ? session.first-1 : session.last+1;
      if(page<1 || page>session.pages || !catalog || catalog.root!==source)return false;
      const url=localURL(session.base);url.searchParams.set('page',String(page));url.searchParams.set('section_id',session.section);
      const html=await request(url,d.controller.signal);
      const fresh=parse(html).querySelector('[data-native-listing]');
      if(!catalog.valid(fresh) || Number(fresh.dataset.page)!==page || Number(fresh.dataset.offset)!==(page-1)*30 || fresh.dataset.total!==source.dataset.total)throw Error('Sequence context changed');
      const next=[...fresh.querySelectorAll('[data-native-grid] [data-native-product]')].map(quickDescriptor).filter(Boolean);
      if(next.length!==Math.min(30,Number(fresh.dataset.total)-(page-1)*30))throw Error('Incomplete sequence');
      const known=new Set(session.items.map(x=>x.id));if(next.some(x=>known.has(x.id)) || new Set(next.map(x=>x.id)).size!==next.length)throw Error('Duplicate sequence');
      if(direction<0){session.items.unshift(...next);session.index+=next.length;session.first=page;}else{session.items.push(...next);session.last=page;}
      return true;
    };
    const load = async (index, focusDirection=null) => {
      const item=session.items[index]; if(!item)return false;
      const url=localURL(item.url);url.searchParams.set('view','kdk-native-quick');
      let html=session.cache.get(item.id||url.pathname);
      if(!html){html=await request(url,d.controller.signal); if(session.cache.size>10)session.cache.delete(session.cache.keys().next().value); session.cache.set(item.id||url.pathname,html);}
      if(!d.element.open)return false;
      const content=parse(html).querySelector('[data-native-quick-content]');
      if(!content || content.dataset.locale!==config.locale || (item.id && content.dataset.product!==item.id))throw Error('Invalid quick view');
      cleanFragment(content);
      if(!mobile.matches)await prepareQuickGallery(content, d.controller.signal);
      if(!d.element.open || d.controller.signal.aborted)return false;
      const scroll=d.body.scrollTop;
      if(!mobile.matches){
        session.contentMin=Math.max(session.contentMin,d.body.querySelector('[data-native-quick-content]')?.getBoundingClientRect().height||0);
        content.style.setProperty('--kdk-quick-content-min',`${session.contentMin}px`);
      }
      session.index=index; session.busy=false;
      d.heading.textContent=content.dataset.title||item.title||t('quick_view');
      d.body.replaceChildren(content);renderControls(content);mount(d.body);d.body.scrollTop=mobile.matches?0:scroll;
      if(focusDirection!==null)content.querySelector(`[data-native-product-step="${focusDirection}"]`)?.focus({preventScroll:true});
      return true;
    };
    const showError = () => {
      if(!d.element.open)return;
      session.busy=false;d.body.querySelector('[data-native-quick-error]')?.remove();
      const box=document.createElement('p');box.dataset.nativeQuickError='';box.role='alert';box.textContent=t('load_error');
      const retry=document.createElement('button');retry.type='button';retry.textContent=t('retry');retry.addEventListener('click',()=>move(session.retryDirection||0));box.append(retry);d.body.prepend(box);
      const content=d.body.querySelector('[data-native-quick-content]');if(content){content.querySelector('.kdk-native-product-controls')?.remove();renderControls(content);}
    };
    const move = async direction => {
      if(session.busy || !d.element.open)return;
      session.busy=true; d.body.setAttribute('aria-busy','true'); d.body.querySelectorAll('[data-native-product-step]').forEach(b=>b.disabled=true);
      try {
        if((session.index+direction<0 || session.index+direction>=session.items.length) && !await boundary(direction))return;
        await load(session.index+direction, direction||null);
      }catch(error){session.retryDirection=direction;showError();}finally{session.busy=false;if(d.element.open){d.body.removeAttribute('aria-busy');const content=d.body.querySelector('[data-native-quick-content]');if(content){const old=content.querySelector('.kdk-native-product-controls');if(old?.querySelectorAll('button:disabled').length===2){old.remove();renderControls(content);}}}}
    };
    d.body.textContent=t('loading');await move(0);
  }
  let searchDialog=null,searchInput=null,searchResults=null,suggestionArea=null,searchController=null,searchSequence=0,debounce=null,composing=false;
  const normalize=value=>String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').trim();
  function searchURL(term) {const url=localURL(config.searchUrl);url.searchParams.set('q',term);url.searchParams.set('type','product');return url;}
  function remember(term) {term=String(term||'').trim();if(!term)return;const values=(read('recent')||[]).filter(x=>x!==term);write('recent',[term,...values].slice(0,5));}
  function suggestions(term) {
    suggestionArea.replaceChildren();
    const normalized=normalize(term), words=normalized.split(' ').filter(w=>w.length>1 && !['cuadros','cuadro','tableau','tableaux','bilder','bild','quadros','quadro','para','pour','fur'].includes(w));
    let list=(config.suggestions||[]).filter(item=>!normalized || words.some(word=>normalize(item.keywords).split(' ').some(k=>k.startsWith(word)||(k.length>=4 && word.startsWith(k)))));
    if (!words.length) list=config.suggestions||[];
    if (list.length) {
      const heading=document.createElement('h3');heading.textContent=t('suggestions');suggestionArea.append(heading);
      for (const item of list.slice(0,8)) {const a=document.createElement('a');a.href=localURL(item.url);a.textContent=item.label;suggestionArea.append(a);}
    }
    const help=(config.help||[]).filter(item=>!normalized || words.some(word=>normalize(item.keywords).includes(word))).slice(0,normalized?4:3);
    if(help.length){const heading=document.createElement('h3');heading.textContent=t('help');suggestionArea.append(heading);for(const item of help){const a=document.createElement('a');a.href=localURL(item.url);a.textContent=item.label;suggestionArea.append(a);}}
    if(!normalized) {
      const recent=read('recent')||[];
      if(recent.length){const heading=document.createElement('h3');heading.textContent=t('recent');suggestionArea.append(heading);
        for(const term of recent){const a=document.createElement('a');a.href=searchURL(term);a.textContent=term;suggestionArea.append(a);}
        const clear=document.createElement('button');clear.type='button';clear.textContent=t('recent_clear');clear.addEventListener('click',()=>{remove('recent');suggestions('');});suggestionArea.append(clear);
      }
    }
  }
  let bestsellersCache=null;
  async function initialSearchProducts(sequence) {
    if(mobile.matches || !searchDialog?.element.open) { searchResults?.replaceChildren(); return; }
    const area=searchResults; area.classList.add('is-bestsellers');area.textContent=t('loading');
    try {
      const url=localURL(config.catalogUrl);url.searchParams.set('sort_by','best-selling');url.searchParams.set('section_id','kdk-native-bestsellers');
      let html=bestsellersCache && Date.now()-bestsellersCache.at<300000 ? bestsellersCache.html : await request(url,searchController?.signal);
      if(sequence!==searchSequence || !searchDialog?.element.open || searchInput.value.trim() || mobile.matches)return;
      const content=parse(html).querySelector('[data-native-bestsellers]');
      if(!content || content.dataset.locale!==config.locale || content.dataset.country!==config.country || content.dataset.currency!==config.currency || content.dataset.theme!==String(config.theme) || content.dataset.sort!=='best-selling')throw Error('Invalid bestseller context');
      bestsellersCache={at:Date.now(),html};area.replaceChildren(cleanFragment(content));mount(area);
    }catch(error){if(sequence===searchSequence && searchDialog?.element.open && !searchInput.value.trim()){area.textContent=t('load_error');}}
  }
  async function predict() {
    const term=searchInput.value.trim();suggestions(term);searchController?.abort();const sequence=++searchSequence;
    searchController=new AbortController();
    if(term.length<2){searchResults.replaceChildren();if(!term)initialSearchProducts(sequence);return;}
    searchResults.classList.remove('is-bestsellers');searchResults.textContent=t('loading');
    const url=localURL(config.predictiveUrl);url.searchParams.set('q',term);url.searchParams.set('resources[type]','product');url.searchParams.set('resources[limit]','8');url.searchParams.set('section_id','kdk-native-predictive');
    try {
      const html=await request(url,searchController.signal);if(sequence!==searchSequence || !searchDialog?.element.open)return;
      const result=parse(html).querySelector('[data-native-predictive-results]');if(!result || result.dataset.locale!==config.locale)throw Error('Invalid predictive response');
      searchResults.replaceChildren(cleanFragment(result));mount(searchResults);
    }catch(error){if(sequence===searchSequence && searchDialog?.element.open)searchResults.textContent=t('load_error');}
  }
  function openSearch(initial='') {
    if(searchDialog?.element.open)return;
    searchDialog=dialog(t('search'),'kdk-native-search-dialog');const d=searchDialog;
    const form=document.createElement('form');form.action=localURL(config.searchUrl);form.method='get';form.role='search';
    const type=document.createElement('input');type.type='hidden';type.name='type';type.value='product';
    searchInput=document.createElement('input');searchInput.type='search';searchInput.name='q';searchInput.autocomplete='off';searchInput.setAttribute('aria-label',t('search'));searchInput.placeholder=t('search_placeholder');searchInput.value=initial;searchInput.maxLength=256;
    const submit=document.createElement('button');submit.type='submit';submit.className='kdk-native-primary';submit.textContent=t('all_results');
    const content=document.createElement('div');content.className='kdk-native-search-columns';
    searchResults=document.createElement('div');searchResults.className='kdk-native-predictive';searchResults.setAttribute('role','region');searchResults.setAttribute('aria-label',t('products'));searchResults.setAttribute('aria-live','polite');
    suggestionArea=document.createElement('aside');suggestionArea.className='kdk-native-suggestions';content.append(searchResults,suggestionArea);
    form.append(type,searchInput,submit);d.body.append(form,content);
    form.addEventListener('submit',e=>{const term=searchInput.value.trim();e.preventDefault();catalog?.snapshot();if(term){remember(term);location.assign(searchURL(term));}else location.assign(localURL(config.catalogUrl));});
    searchInput.addEventListener('keydown',e=>{if(e.key==='ArrowDown'){const first=searchResults.querySelector('a')||suggestionArea.querySelector('a');if(first){e.preventDefault();first.focus();}}});
    content.addEventListener('keydown',e=>{if(!['ArrowUp','ArrowDown'].includes(e.key))return;const links=[...content.querySelectorAll('a')];const i=links.indexOf(document.activeElement);if(i<0)return;e.preventDefault();const next=i+(e.key==='ArrowDown'?1:-1);if(next<0)searchInput.focus();else links[Math.min(next,links.length-1)]?.focus();});
    searchInput.addEventListener('compositionstart',()=>{composing=true;});searchInput.addEventListener('compositionend',()=>{composing=false;clearTimeout(debounce);predict();});
    searchInput.addEventListener('input',()=>{if(composing)return;clearTimeout(debounce);debounce=setTimeout(predict,180);});
    d.element.addEventListener('close',()=>{searchSequence++;searchController?.abort();clearTimeout(debounce);searchDialog=null;},{once:true});
    searchInput.focus({preventScroll:true});suggestions(initial);predict();
  }
  function header() {
    document.querySelectorAll('[data-kdk-native-search-input]').forEach(input=>{
      input.placeholder=mobile.matches ? t('search')+'…' : t('search_placeholder');input.setAttribute('aria-label',t('search'));
    });
  }
  function updateHeaderPlaceholder(){document.querySelectorAll('[data-kdk-native-search-input]').forEach(input=>input.placeholder=mobile.matches?t('search')+'…':t('search_placeholder'));}
  document.addEventListener('click',e=>{
    if(!eligibleClick(e))return;
    if(openSort && !openSort.form.contains(e.target))closeSort();
    const galleryImage=e.target.closest('[data-native-quick-gallery] > img');
    if(galleryImage && !mobile.matches){scrollQuickImage(galleryImage);return;}
    if(mobile.matches && e.target===catalog?.root.querySelector('[data-native-filter-shell][open]')){filters(false,true);return;}
    const target=e.target.closest('a,button,input');if(!target)return;
    const searchTrigger=target.matches('[data-kdk-native-search-open],[data-kdk-native-search-input],[data-action="toggle-search"],.Search__Input');
    if(searchTrigger && !target.closest('.kdk-native-dialog')){e.preventDefault();e.stopImmediatePropagation();openSearch(target.value||target.dataset.query||'');return;}
    if(target.matches('[data-native-quick]')){e.preventDefault();catalog?.snapshot();quick(target);return;}
    if(target.matches('[data-native-visualize]')){e.preventDefault();catalog?.snapshot();visualize(target);return;}
    if(target.matches('[data-native-product-link]'))catalog?.snapshot();
    if(!catalog || !catalog.root.contains(target))return;
    if(target.matches('[data-native-more],[data-native-page],[data-native-link]')){e.preventDefault();filters(false);catalog.navigate(target.href,target.matches('[data-native-more]'));return;}
    if(target.matches('[data-native-retry]')){if(catalog.pending)catalog.navigate(catalog.pending.raw,catalog.pending.append,catalog.pending.historyMode);return;}
    if(target.matches('[data-native-open-filters]')){filters(true);return;}
    if(target.matches('[data-native-close-filters]')){filters(false,true);return;}
    if(target.matches('[data-native-view]')){state.view=target.dataset.nativeView;document.documentElement.dataset.kdkNativeView=state.view;catalog.hydrate();write('preferences',state);return;}
    if(target.matches('[data-native-wall]')){state.wall=target.dataset.nativeWall.toLowerCase();catalog.hydrate();write('preferences',state);}
  },true);
  document.addEventListener('focusin',e=>{if(Date.now()>suppressHeaderFocusUntil && e.target.matches('[data-kdk-native-search-input]')&&!searchDialog?.element.open)openSearch(e.target.value||'');});
  document.addEventListener('submit',e=>{
    const form=e.target;
    if(catalog?.root.contains(form) && form.matches('[data-native-filter-form],[data-native-sort-form]')){e.preventDefault();const url=catalog.formURL(form);filters(false);catalog.navigate(url);}
  });
  document.addEventListener('change',e=>{
    if(!catalog?.root.contains(e.target))return;
    if(e.target.matches('[data-native-sort]')){syncSortForms(e.target.form);e.target.form.requestSubmit();}
    else if(e.target.matches('[data-native-filter-form] input[type="checkbox"]')&&!mobile.matches)e.target.form.requestSubmit();
  });
  document.addEventListener('pointerover',e=>{if(e.pointerType==='mouse')e.target.closest('.kdk-native-card')?.querySelectorAll('[data-native-scene]').forEach(mediaSource);});
  document.addEventListener('focusin',e=>e.target.closest('.kdk-native-card')?.querySelectorAll('[data-native-scene]').forEach(mediaSource));
  document.addEventListener('keydown',e=>{
    if(e.target.matches('[data-native-quick-gallery]') && ['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){
      const gallery=e.target; const images=[...gallery.querySelectorAll('img')];
      const current=images.reduce((best,img,i)=>Math.abs(img.getBoundingClientRect().left-gallery.getBoundingClientRect().left)<Math.abs(images[best].getBoundingClientRect().left-gallery.getBoundingClientRect().left)?i:best,0);
      const index=e.key==='Home'?0:e.key==='End'?images.length-1:Math.max(0,Math.min(images.length-1,current+(e.key==='ArrowRight'?1:-1)));
      if(images[index]){e.preventDefault();scrollQuickImage(images[index]);}return;
    }
    const shell=catalog?.root.querySelector('[data-native-filter-shell][open]');
    if(!mobile.matches || !shell || [...dialogSet].some(d=>d.open))return;
    if(e.key==='Escape'){e.preventDefault();filters(false,true);}
    if(e.key==='Tab'){
      const nodes=[...shell.querySelectorAll('button,a,input,summary,select')].filter(el=>!el.disabled&&el.getClientRects().length);
      const first=nodes[0],last=nodes.at(-1);
      if(e.shiftKey && (document.activeElement===first || document.activeElement===shell.querySelector('[data-native-filter-panel]'))){e.preventDefault();last?.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}
    }
  });
  let frame=0;
  addEventListener('scroll',()=>{scrollDirection=scrollY>=lastScroll?1:-1;lastScroll=scrollY;if(!frame)frame=requestAnimationFrame(()=>{frame=0;catalog?.compact();videoSet.forEach(updateVideo);});},{passive:true});
  addEventListener('pagehide',()=>catalog?.snapshot());
  addEventListener('popstate',()=>{if(catalog){if(catalog.currentURL===location.href){window.KdkNativeHistory?.restore();return;}catalog.snapshot();if(!catalog.restore())catalog.navigate(location.href,false,'none');}});
  addEventListener('pageshow',e=>{if(e.persisted){catalog?.hydrate();overlayState();}});
  mobile.addEventListener('change',()=>{closeSort();catalog?.hydrate();updateHeaderPlaceholder();if(searchDialog?.element.open && !searchInput?.value.trim()){searchSequence++;searchController?.abort();searchController=new AbortController();searchResults.replaceChildren();initialSearchProducts(searchSequence);}});
  reduced.addEventListener('change',()=>videoSet.forEach(updateVideo));
  document.addEventListener('visibilitychange',()=>videoSet.forEach(updateVideo));
  document.addEventListener('wishlist-hero-wishlist-sdk-ready',()=>{wishlist();queueWishlistRefresh();});
  if(window.WishListHero_SDK)queueWishlistRefresh();

  function boot(){
    header();
    const url=new URL(location.href);
    if(/\/search\/?$/.test(url.pathname) && url.searchParams.get('q')?.trim() && url.searchParams.get('type')!=='product'){url.searchParams.set('type','product');location.replace(url);return;}
    const root=document.querySelector('[data-native-listing]');if(root && root!==catalog?.root)catalog=new Catalog(root);}
  boot();if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  document.addEventListener('shopify:section:load',boot);
  window.KdkNative={version:config.version,openSearch,context,debug:()=>({mode:catalog?.root.dataset.mode,page:catalog?.root.dataset.page,total:catalog?.root.dataset.total,pending:!!catalog?.pending})};
})();
